import {
  Info,
  PackageMinus,
  PackagePlus,
  // Edit,
  // Trash2
} from 'lucide-react'
import { useInventoryStore } from '../store/inventoryStore'
import type { InventoryStock } from '@/features/inventory/types/inventory'
import type { PermissionHelper } from '@/utils/permissions'
import { usePermissions } from '@/utils/permissions'
import { Badge } from '@/components/custom/badge'
import { Button } from '@/components/ui/button'

interface InventoryCardProps {
  stockItem: InventoryStock
  permissions: PermissionHelper
  onEdit: (itemId: string) => void
  onDelete: (itemId: string) => void
  onDetail: (itemId: string) => void
  onStockIn: (itemId: string) => void
  onStockOut: (itemId: string) => void
}

export function InventoryCard({
  stockItem,
  // permissions,
  // onEdit,
  // onDelete,
  onDetail,
  onStockIn,
  onStockOut,
}: InventoryCardProps) {
  const permissions = usePermissions()

  const categories = useInventoryStore((s) => s.categories)
  const itemCategory = categories.find(
    (cat) => cat._id === stockItem.categoryId,
  )

  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">{stockItem.item}</div>
        <Badge color={stockItem.quantity > 0 ? 'green' : 'red'}>
          {stockItem.quantity > 0 ? 'In Stock' : 'Out of Stock'}
        </Badge>
      </div>

      <div className="space-y-2 mb-4">
        <div className="text-sm">
          <span className="font-medium text-gray-600">Category: </span>
          <span>{itemCategory?.name}</span>
        </div>
        <div className="text-sm">
          <span className="font-medium text-gray-600">Quantity: </span>
          <span>{stockItem.quantity}</span>
        </div>
        {stockItem.unit && (
          <div className="text-sm">
            <span className="font-medium text-gray-600">Unit: </span>
            <span>{stockItem.unit}</span>
          </div>
        )}
        {stockItem.description && (
          <div className="text-sm">
            <span className="font-medium text-gray-600">Description: </span>
            <span>{stockItem.description}</span>
          </div>
        )}

        {stockItem.location && (
          <div className="text-sm">
            <span className="font-medium text-gray-600">Location: </span>
            <span>{stockItem.location}</span>
          </div>
        )}
        {stockItem.minThreshold && (
          <div className="text-sm">
            <span className="font-medium text-gray-600">
              Minimum Threshold:{' '}
            </span>
            <span>{stockItem.minThreshold}</span>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col gap-2">
        {permissions.canAccessInventory() && (
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            onClick={() => onDetail(stockItem._id)}
          >
            <Info className="h-4 w-4 mr-2" /> Details
          </Button>
        )}

        <div className="flex gap-2">
          {permissions.canAccessInventory() && (
            <Button
              className="flex-1"
              size="sm"
              onClick={() => onStockIn(stockItem._id)}
            >
              <PackagePlus className="h-4 w-4" /> Add Inventory
            </Button>
          )}
          {permissions.canAccessInventory() && stockItem.quantity > 0 && (
            <Button
              className="flex-1"
              size="sm"
              onClick={() => onStockOut(stockItem._id)}
            >
              <PackageMinus className="h-4 w-4" /> Remove Inventory
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
